import moment from 'moment-timezone';

import { CSV_FULL_DATE_FORMAT, DATE_DAILY_SHORT_FORMAT } from '../../constants/date';
import { fieldTypes } from '../../constants/metainf';
import { COLUMNS_CSV, FIELDS_FULL_DATE } from '../../utils/csv';
import { splitPostfix } from '../../constants/event';

// для того чтобы в cvs печатался 'null' как строка
const getNotNullValue = (entity) => (entity === null ? 'null' : entity);

export const toDateFormat = (column, data, timezone) =>
  FIELDS_FULL_DATE.includes(column)
    ? moment.tz(+data, timezone).format(CSV_FULL_DATE_FORMAT)
    : moment.tz(+data, timezone).format(DATE_DAILY_SHORT_FORMAT);

const getGroupByFunctions = (row, groupBy, typeColumns, timezone) => {
  const groupByFn = () => {
    const type = typeColumns[groupBy];

    const resultValue = [fieldTypes.TIME, fieldTypes.COHORT, fieldTypes.DATE].includes(type)
      ? toDateFormat(groupBy, row[groupBy], timezone)
      : row[groupBy];

    const notNullresultValue = getNotNullValue(resultValue);
    return notNullresultValue;
  };

  const groupByMsFn = () => row[groupBy];

  return {
    groupByFn,
    groupByMsFn,
  };
};

const getSplitByFunctions = (row, splitBy, typeColumns, timezone) => {
  const splitByFn = (splitByVar = splitBy) => {
    const type = typeColumns[splitBy];

    const resultValue =
      [fieldTypes.TIME, fieldTypes.COHORT, fieldTypes.DATE].includes(type) &&
      row[splitByVar] !== 'others'
        ? toDateFormat(splitBy, row[splitByVar], timezone)
        : row[splitByVar];

    const notNullresultValue = getNotNullValue(resultValue);
    return notNullresultValue;
  };

  const splitByMsFn = () => row[splitBy];

  return {
    splitByFn,
    splitByMsFn,
  };
};

const getAggregationsFunctions = (row) => {
  const countFn = () => {
    if (row[COLUMNS_CSV.COUNT]) {
      return row[COLUMNS_CSV.COUNT];
    }
    if (row[COLUMNS_CSV.AVERAGE_COUNT]) {
      return row[COLUMNS_CSV.AVERAGE_COUNT];
    }
    if (row[COLUMNS_CSV.AVERAGE_COUNT_SPLIT]) {
      return row[COLUMNS_CSV.AVERAGE_COUNT_SPLIT];
    }
    if (row[COLUMNS_CSV.USERS]) {
      return row[COLUMNS_CSV.USERS];
    }
    return undefined;
  };

  const avgFn = () => {
    const total = row[Object.keys(row).find((key) => key.includes(COLUMNS_CSV.TOTAL))];
    const count = row[COLUMNS_CSV.COUNT];
    return !!total && !!count ? total / count : '';
  };

  const totalFn = () => row[Object.keys(row).find((key) => key.includes(COLUMNS_CSV.TOTAL))];

  const avgTotalFn = () => row[Object.keys(row).find((key) => key.includes(COLUMNS_CSV.TOTAL))];

  return {
    countFn,
    avgFn,
    totalFn,
    avgTotalFn,
  };
};

const getFormatValue = (row, column, typeColumns, { groupBy, splitBy, timezone }) => {
  const { groupByFn, groupByMsFn } = getGroupByFunctions(row, groupBy, typeColumns, timezone);
  const { splitByFn, splitByMsFn } = getSplitByFunctions(row, splitBy, typeColumns, timezone);
  const { countFn, avgFn, totalFn, avgTotalFn } = getAggregationsFunctions(row);

  const splitByWithPostfix = `${splitBy}${splitPostfix}`;

  const functionByParam = {
    [groupBy]: groupByFn,
    [COLUMNS_CSV.MS + groupBy]: groupByMsFn,
    [splitBy]: splitByFn,
    [COLUMNS_CSV.MS + splitBy]: splitByMsFn,
    [COLUMNS_CSV.COUNT]: countFn,
    [COLUMNS_CSV.TOTAL]: totalFn,
    [COLUMNS_CSV.AVG_TOTAL]: avgTotalFn,
    [COLUMNS_CSV.MAX]: () => row[COLUMNS_CSV.MAX],
    [COLUMNS_CSV.MIN]: () => row[COLUMNS_CSV.MIN],
    [COLUMNS_CSV.AVG]: avgFn,
    [splitByWithPostfix]: () => splitByFn(splitByWithPostfix),
    [COLUMNS_CSV.MS + splitByWithPostfix]: splitByMsFn,
  };

  return functionByParam[column]();
};

/**
 * @param rows массив строк, где каждая строка содержит объект с данными.
 * @param columns массив в котором определен порядок ключей объекта строки.
 * @param types типы полей для group by и split by.
 * @param info данные запроса.
 * @returns строку содержащую все преобразованные строки и разделенные '\n'.
 */
const csvRowsPrinter = (rows, columns, types, info) =>
  rows
    .map((row) => {
      const col = columns.map((column) => getFormatValue(row, column, types, info));
      return col.join(';');
    })
    .join('\n');

export const csvRowsPrinterWithAdditional = (rows, columns, types, info) => {
  return rows.map((row) => columns.map((column) => getFormatValue(row, column, types, info)));
};

export default csvRowsPrinter;
